(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

    function initPopup(popup) {
      const sectionId = popup.dataset.sectionId;
      const redisplayDays = parseInt(popup.dataset.redisplayDays, 10);
      const storageKey = 'popup_closed_at_' + sectionId;

      function shouldShow() {
        if (isDesignMode) return true;
        if (redisplayDays === 0) return true;
        const closedAt = localStorage.getItem(storageKey);
        if (!closedAt) return true;
        return Date.now() - parseInt(closedAt, 10) > redisplayDays * 86400000;
      }

      function closePopup() {
        popup.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (!isDesignMode && redisplayDays > 0) {
          localStorage.setItem(storageKey, String(Date.now()));
        }
      }

      if (!shouldShow()) return;

      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      popup.querySelector('.popup-close').addEventListener('click', closePopup);

      popup.addEventListener('click', function (e) {
        if (!e.target.closest('.popup-inner') && !e.target.closest('.popup-close')) closePopup();
      });

    }

    function initAll() {
      document.querySelectorAll('.popup-section').forEach(initPopup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const popup = document.querySelector('#popup-' + event.detail.sectionId);
      if (popup) initPopup(popup);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
